module.exports = __webpack_public_path__ + "static/media/Our-People-Option-1.0747ce10.png";